import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { EndpointStatus, StatusService } from '../../app/door/statusService';
import { DoorStatus } from '../../app/model';
import { CfgPage } from '../cfg/cfg';
import { Subscription } from 'rxjs/Subscription';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  styles: [
`
.door-status {
  background-color: inherit;
  transition: 200ms ease-in all;

}
.door-status-updated {
  background-color: #edf4ff ;
}
`
  ]
})
export class HomePage {

  constructor(public navCtrl: NavController, public ss: StatusService, private toastCtrl: ToastController) {

  }
  private sub_statusUpdated: Subscription;
  public doorStatusClasses: {[id:string]: string} = {};

  public ionViewDidEnter() {
    if (this.ss.evt_statusUpdated == undefined) {
      console.error("this.ss.evt_statusUpdated undefined");
    }
    else {
    this.sub_statusUpdated = this.ss.evt_statusUpdated.subscribe(status => {
      console.info(`STATUS UPDATED ${JSON.stringify(status.statusResponseDTO.doors.map(d => d.sid))}`);

      status.statusResponseDTO.doors.forEach(d => {
        this.doorStatusClasses[d.sid]= " door-status door-status-updated ";
        setTimeout(() => { this.doorStatusClasses[d.sid]= " door-status "; }, 10);
      });
    });
    }
    this.ss.getStatus();
    this.setupRefreshOnActivate();
  }
  public ionViewDidLeave () {
    this.removeRefreshOnActivate();
    if (this.sub_statusUpdated) {
      this.sub_statusUpdated.unsubscribe();
      this.sub_statusUpdated = undefined;
    }
  }

  public refresh = (refresher: any) => {
    this.ss.getStatus().then(() => {
      refresher.complete();
    }, (error) => {
      refresher.cancel();
    }).catch (ex => {
      refresher.cancel();
    });
  }

  public navigateToCfg = () => {
    this.navCtrl.push(CfgPage, {addNew: true});
  }

  public autoRefresh = () => {
    this.ss.autoRefreshAll(300000, 1000);
  }

  public toggleRunning: { [id: string]: boolean; } = {};
  public toggleError: string;
  public toggle = (ps: EndpointStatus, s: DoorStatus, action?: string) => {
    this.toggleRunning[s.sid] = true;
    this.ss.toggle(ps, s, action).then(() => {
      this.toggleRunning[s.sid] = false;
      this.toggleError = undefined;
      this.toastCtrl.create({message: "Success", duration: 1000, position:'bottom'}).present();
    }, (error) => {
      this.toggleRunning[s.sid] = false;
      this.toggleError = `Error: ${error}`;
      this.toastCtrl.create({message: this.toggleError, duration: 5000, position:'bottom'}).present();
    }).catch (ex => {
      this.toggleRunning[s.sid] = false;
      this.toggleError = `Error: ${ex}`;
      this.toastCtrl.create({message: this.toggleError, duration: 5000, position:'bottom'}).present();
    })
  }


  private visibilityListenerActive = false;
  private setupRefreshOnActivate = () => {
    var visProp = this.getHiddenProp();
    if (visProp) {
      var evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
      document.addEventListener(evtname, this.onVisChanged);
      this.visibilityListenerActive = true;
    }
  }
  private removeRefreshOnActivate = () => {
    var visProp = this.getHiddenProp();
    if (visProp) {
      var evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
      document.removeEventListener(evtname, this.onVisChanged);
      this.visibilityListenerActive = false;
    }
  }
  private onVisChanged = () =>
  {
    const h = this.isHidden();
    // console.info(`Page visibility changed: ${!h}`);
    if (!h) {
      this.ss.getStatus();
    }
  }
  private getHiddenProp(){
    var prefixes = ['webkit','moz','ms','o'];

    // if 'hidden' is natively supported just return it
    if ('hidden' in document) return 'hidden';

    // otherwise loop over all the known prefixes until we find one
    for (var i = 0; i < prefixes.length; i++){
        if ((prefixes[i] + 'Hidden') in document)
            return prefixes[i] + 'Hidden';
    }

    // otherwise it's not supported
    return null;
  }
  private isHidden() {
    var prop = this.getHiddenProp();
    if (!prop) return false;

    return document[prop];
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts